import { useRef } from 'react';
import styled from 'styled-components';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import { WrTooltip } from '../../../styled-components/common/wr-tooltip';
import LearningObjectIcon from './LearningObjectIcon';

interface Task {
  id: string;
  title?: string;
}

interface Props {
  task: Task;
  isActive?: boolean;
  selectableAssets: {
    [key: string]: (task: Task) => void;
  };
}

const AssetPickerGuideTask = ({ task, isActive, selectableAssets }: Props) => {
  const taskNameRef = useRef<HTMLDivElement>(null);
  const activeClass = isActive ? 'asset-picker-asset--active' : '';
  const name = task.title || 'Untitled Task';

  const handleSelectTaskClick = (): void => {
    const callback = selectableAssets[AssetPickerTypes.GUIDE_TASK];
    if (callback) callback(task);
  };

  // TODO: Using LearningObjectIcon because ContentIcon is missing GUIDE_TASK icon
  return (
    <div className={`asset-picker-asset asset-picker-guide-task ${activeClass}`}>
      <div className="asset-picker-asset--header" ref={taskNameRef}>
        <StyledButton type="button" className="asset-picker-asset--label" onClick={handleSelectTaskClick}>
          <LearningObjectIcon
            type={AssetPickerTypes.GUIDE_TASK}
            iconClassName="asset-picker-asset--icon"
            height="16px"
            width="16px"
            style={{}}
          />
          <div className="asset-picker-asset--name">
            <WrTooltip arrow={false} content={name} direction="down-start" tagName="span" zIndex={2000} inline>
              {name}
            </WrTooltip>
          </div>
        </StyledButton>
      </div>
    </div>
  );
};

const StyledButton = styled.button`
  text-align: left;
  border: none;
  background: none;
`;

export default AssetPickerGuideTask;
